module App.Interfaces {
    export interface IStepController {
        stepName: string;
        isValid(isLogicCheck: boolean = false): boolean;
    }
}